import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "v-row",
  style: {"margin":"0 8px 12px 0","gap":"8px","flex-wrap":"wrap","--button-icon-size":"1.5em"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("播放全部")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("添加到")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item separator first" }, "我的收藏", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item last" }, "添加到新歌单", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item separator first" }, "我的收藏", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item last" }, "添加到新歌单", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item separator first" }, "我的收藏", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item last" }, "添加到新歌单", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item separator first" }, "我的收藏", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item last" }, "添加到新歌单", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item separator first" }, "我的收藏", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item last" }, "添加到新歌单", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item separator first" }, "我的收藏", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item last" }, "添加到新歌单", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("导入歌曲")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("排序方式")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hl_button = _resolveComponent("hl-button")!
  const _component_popover = _resolveComponent("popover")!
  const _component_text_field = _resolveComponent("text-field")!
  const _component_table_view = _resolveComponent("table-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_hl_button, {
        icon: "play-select",
        onClick: _ctx.playSelect
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_popover, { closeable: "" }, {
        content: _withCtx(() => [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _hoisted_13,
          _hoisted_14,
          _hoisted_15
        ]),
        default: _withCtx(() => [
          _createVNode(_component_hl_button, { icon: "plus" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_hl_button, { icon: "my-download" }, {
        default: _withCtx(() => [
          _hoisted_16
        ]),
        _: 1
      }),
      _createVNode(_component_hl_button, {
        icon: "trash",
        "icon-size": "1.5em"
      }, {
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      }),
      _createVNode(_component_hl_button, {
        icon: "multiple",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.multiple = !_ctx.multiple))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.multiple ? '退出批量操作' : '批量操作'), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_text_field, {
        modelValue: _ctx.inputKey,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputKey) = $event)),
        placeholder: "搜索本地歌曲",
        onInput: _ctx.handleMusicFilter,
        style: {"margin":"0 0 0 auto"}
      }, null, 8, ["modelValue", "onInput"]),
      _createVNode(_component_hl_button, {
        icon: "import",
        onClick: _ctx.onImportButtonClicked
      }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createElementVNode("input", {
        type: "file",
        style: {"display":"none"},
        ref: "fileChooser",
        multiple: "",
        accept: "audio/*",
        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addMusic && _ctx.addMusic(...args)))
      }, null, 544),
      _createVNode(_component_hl_button, {
        icon: "sort",
        style: {"--button-icon-size":"1.2em"}
      }, {
        default: _withCtx(() => [
          _hoisted_19
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_table_view, {
      style: {"flex":"auto"},
      columns: _ctx.columns,
      data: _ctx.list,
      selection: _ctx.multiple,
      onRowDblclick: _ctx.playMediaList
    }, null, 8, ["columns", "data", "selection", "onRowDblclick"])
  ], 64))
}